import {ProductReviewData} from '../../ui/ProductReviewData'
import {ProductReviewSection} from '../../ui/ProductReviewSection'
import {PRODUCT_REVIEW_ADDITIONAL_INFORMATION_SECTION} from '../productReviewDataMap'

export const AdditionalInformationSection = () => {
  return (
    <ProductReviewSection title="Additional Information" icon="info">
      <ProductReviewData sections={[PRODUCT_REVIEW_ADDITIONAL_INFORMATION_SECTION]} />
    </ProductReviewSection>
  )
}
